var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18959",
    "data-name": "Group 18959",
    transform: "translate(-218 -142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(218 142)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 76,
    cy: 76,
    r: 76,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M76,4.75A71.25,71.25,0,0,0,25.619,126.381,71.25,71.25,0,1,0,126.381,25.619,70.783,70.783,0,0,0,76,4.75M76,0A76,76,0,1,1,0,76,76,76,0,0,1,76,0Z",
    fill: "#ffd055"
  })), /*#__PURE__*/React.createElement("path", {
    id: "camera_1_",
    "data-name": "camera (1)",
    d: "M66.112,51.123H59.128l-2.636-5.271a12.176,12.176,0,0,0-10.951-6.768H32.814a12.176,12.176,0,0,0-10.951,6.768l-2.636,5.271H12.243A12.257,12.257,0,0,0,0,63.366V93.234a12.257,12.257,0,0,0,12.243,12.243H66.112A12.257,12.257,0,0,0,78.355,93.234V63.366A12.257,12.257,0,0,0,66.112,51.123Zm6.122,42.111a6.128,6.128,0,0,1-6.122,6.121H12.243a6.128,6.128,0,0,1-6.122-6.121V63.366a6.128,6.128,0,0,1,6.122-6.122h8.876a3.061,3.061,0,0,0,2.738-1.692l3.482-6.963a6.088,6.088,0,0,1,5.475-3.384H45.542a6.088,6.088,0,0,1,5.475,3.384L54.5,55.552a3.06,3.06,0,0,0,2.738,1.692h8.876a6.128,6.128,0,0,1,6.122,6.122ZM39.178,60.1a15.1,15.1,0,1,0,15.1,15.1A15.117,15.117,0,0,0,39.178,60.1Zm0,24.078A8.978,8.978,0,1,1,48.156,75.2,8.988,8.988,0,0,1,39.178,84.179Z",
    transform: "translate(254.822 145.72)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.3712984939af5baec130b3602cf2f651.svg";
export { ForwardRef as ReactComponent };